import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  useGlobalSearchDataInternal,
  UseGlobalSearchDataReturnType,
} from 'hooks/useGlobalSearchData/useGlobalSearchDataInternal';
import { SearchPageType } from 'lib/utils/global.search';

const initialContext: UseGlobalSearchDataReturnType = {
  pageTitle: '',
  featuredOpportunities: [],
  isFeaturedOpportunitiesLoading: false,
  matchesOpportunities: [],
  isMatchesOpportunitiesLoading: false,
  universityEvents: [],
  isUniversityEventsLoading: false,
  opportunities: [],
  totalOpportunitiesCount: 0,
  noOpportunities: false,
  isOpportunitiesLoading: false,
  isOpportunitiesValidating: false,
  hasMoreOpportunities: false,
  universityCommunities: [],
  isUniversityCommunitiesLoading: false,
  communities: [],
  isCommunitiesLoading: false,
  isCommunitiesValidating: false,
  hasMoreCommunities: false,
  totalCommunitiesCount: 0,
  noCommunities: false,
  companies: [],
  isCompaniesLoading: false,
  isCompaniesValidating: false,
  hasMoreCompanies: false,
  totalCompaniesCount: 0,
  noCompanies: false,
  isFilteredRecordsLoading: false,
  filteredRecordsCount: 0,
  selectedOpportunity: null,
  isSelectedOpportunityLoading: false,
  isInitialLoading: false,
  onSelectOpportunity: noop,
  nextOpportunityPage: noop,
  nextCommunityPage: noop,
  nextCompanyPage: noop,
  hasPreviousOpportunity: false,
  hasNextOpportunity: false,
  handlePreviousOpportunity: noop,
  handleNextOpportunity: noop,
  onUpdateSelectedOpportunity: noop,
};

const GlobalSearchDataContext =
  createContext<UseGlobalSearchDataReturnType>(initialContext);

export const useGlobalSearchData = () => useContext(GlobalSearchDataContext);

export const GlobalSearchDataProvider: React.FC<{
  type: SearchPageType;
  pageTitle?: string;
}> = ({ children, type, pageTitle }) => {
  const value = useGlobalSearchDataInternal({ type, pageTitle });

  return (
    <GlobalSearchDataContext.Provider value={value}>
      {children}
    </GlobalSearchDataContext.Provider>
  );
};
